import { QA_MODAL_KEY } from '../../../../../constants/qa'

export const SPLIT_PANE_ESCAPE_MODAL_SELECTOR = `[${QA_MODAL_KEY}]`

export const SPLIT_PANE_ESCAPE_EDITING_SELECTOR =
  'form, input, textarea, [contenteditable="true"]'
